import { render, staticRenderFns } from "./Clinic.vue?vue&type=template&id=6cc27768&scoped=true&"
import script from "./Clinic.vue?vue&type=script&lang=ts&"
export * from "./Clinic.vue?vue&type=script&lang=ts&"
import style0 from "./Clinic.vue?vue&type=style&index=0&id=6cc27768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc27768",
  null
  
)

export default component.exports